<template>
	<section class="gaokao-content" style="width: 1200px;margin:0 auto 20px auto;">
		<div class="head_tab flex">
			<p class="shou" :class="isTab == 0 ? 'on' : ''" @click="onTab(0)">关注院校</p>
			<p class="shou" :class="isTab == 1 ? 'on' : ''" @click="onTab(1)">关注专业</p>
			<p class="shou" :class="isTab == 2 ? 'on' : ''" @click="onTab(2)">关注课程</p>
			<p class="shou" :class="isTab == 3 ? 'on' : ''" @click="onTab(3)">关注文章</p>
		</div>

		<div class="tb_padding" v-show="isTab == 0 || isTab == 1">
			<div class="tbc_tabel ">
				<article class="table">
					<el-table :data="tableData" :row-class-name="tableRowClassName" ref="singleTable"
						highlight-current-row border row-key="Id" style="width: 100%" height="600px">
						<el-table-column prop="CollegesName" :label="Column.CollegesNameStr || '院校名称'" width="120">
							<template slot-scope="scope">
								<div class="name_div ">
									<div class="flex zhong">
										<p style="width: calc(100% - 25px);cursor: pointer;"
											@click="xueTo(scope.row.CollegesName)">{{ scope.row.CollegesName }}</p>
										<el-tooltip class="item" effect="dark" :content="scope.row.CollegesName"
											placement="bottom">
											<img src="../../image/shkl.png"
												style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
										</el-tooltip>
									</div>
									<p>院校代码：{{ scope.row.CollegesCode }}</p>
									<p>院校类别：{{ scope.row.CollegesType }}</p>
									<p>院校类型：{{ scope.row.CollegesMold }}</p>
									<p>特色：{{ scope.row.Characte }}</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="CollegesArea" :label="Column.CollegesAreaStr || '院校地区'" width="70">
						</el-table-column>
						<el-table-column prop="MajorCode" :label="Column.MajorCodeStr || '专业代码'" width="60">
						</el-table-column>
						<el-table-column :label="Column.MajorNameStr || '专业名称'" width="65">
							<template slot-scope="scope">
								<div class="name_div ">
									<div class="flex zhong">
										<p style="width: calc(100% - 25px);cursor: pointer;"
											@click="zhuanyeTo(scope.row.MajorProfile.length > 0 ? scope.row.MajorProfile[0].Id : 0)">
											{{ scope.row.MajorName == null ? '' : scope.row.MajorName.length > 12 ? scope.row.MajorName.substring(0, 11) : scope.row.MajorName }}
										</p>
										<el-tooltip class="item" effect="dark" :content="scope.row.MajorName"
											placement="bottom">
											<img src="../../image/shkl.png"
												style="width: 23px;height: 16px;margin-left: 0.5em;cursor: pointer;" />
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="Column.EducationalStr || '学制/学费'" width="60">
							<template slot-scope="scope">
								<div class="name_div ">
									<p>{{ scope.row.Educational }}/{{ scope.row.Tuition }}</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="Column.NewPlanStr || '计划'">
							<el-table-column prop="NewPlan"
								:label="(isTab === 0 ? Column.CollegeYear : Column.Year) || ''" width="60">
							</el-table-column>
						</el-table-column>
						<el-table-column :label="Column.YearsDateStr || '历年数据'">
							<el-table-column prop="yeara" :label="isTab === 0 ? Column.CollegeYear1 : Column.Year1"
								width="84">
								<template slot-scope="scope">
									<div class="name_div ">
										<p>平均分：{{ scope.row.YearsDate1 != null ? scope.row.YearsDate1.Average : '' }}
										</p>
										<p>最低分：{{ scope.row.YearsDate1 != null ? scope.row.YearsDate1.LowestScore : '' }}
										</p>
										<p>最低位次：{{ scope.row.YearsDate1 != null ? scope.row.YearsDate1.LowestOrder : '' }}
										</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="yearb" :label="isTab === 0 ? Column.CollegeYear2 : Column.Year2"
								width="84">
								<template slot-scope="scope">
									<div class="name_div ">
										<p>平均分：{{ scope.row.YearsDate2 != null ? scope.row.YearsDate2.Average : '' }}
										</p>
										<p>最低分：{{ scope.row.YearsDate2 != null ? scope.row.YearsDate2.LowestScore : '' }}
										</p>
										<p>最低位次：{{ scope.row.YearsDate2 != null ? scope.row.YearsDate2.LowestOrder : '' }}
										</p>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="yearc" :label="isTab === 0 ? Column.CollegeYear3 : Column.Year3"
								width="84">
								<template slot-scope="scope">
									<div class="name_div ">
										<p>平均分：{{ scope.row.YearsDate3 != null ? scope.row.YearsDate3.Average : '' }}
										</p>
										<p>最低分：{{ scope.row.YearsDate3 != null ? scope.row.YearsDate3.LowestScore : '' }}
										</p>
										<p>最低位次：{{ scope.row.YearsDate3 != null ? scope.row.YearsDate3.LowestOrder : '' }}
										</p>
									</div>
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="PreferredSubject" :label="Column.PreferredSubjectStr || '首选科目'"
							width="50"></el-table-column>
						<el-table-column prop="RequirementsSubjects" :label="Column.RequirementsSubjectsStr || '选考科目'"
							width="50"></el-table-column>
						<el-table-column :label="Column.SolutionStr || '招生章程'" width="50">
							<template slot-scope="scope">
								<p><a :href="scope.row.Solution" target="_blank">章程</a></p>
							</template>
						</el-table-column>
						<el-table-column label="关注" width="60">
							<template slot-scope="scope">
								<img :src="require('../../image/gz_aa.png')" class="scImg"
									@click="CkeUserAttention(scope.$index)" />
							</template>
						</el-table-column>
					</el-table>
				</article>
			</div>
			<div class="flex zhong center" style="margin-top: 30px;">
				<el-pagination v-if="IsPage" class="fy" layout="prev, pager, next" @current-change="current_change"
					:page-count="page" :total="total" background></el-pagination>
			</div>
		</div>

		<!-- 关注课程 -->
		<div class="guan_div" v-show="isTab == 2">
			<div v-if="isGuanData">
				<ul>
					<li class="flex float" v-for="(item, index) in tableData" :key="index">
						<div class="li_img" @click="classTo(item.ContentId)"><img :src="item.PcCoverStr" /></div>
						<div class="li_you">
							<h6 class="shl" @click="classTo(item.ContentId)">{{item.Title}}</h6>
							<div class="li_time flex float">
								<hgroup class="flex zhong " style="    width: calc( 100% - 100px );" @click="classTo(item.ContentId)">
									<span>共{{item.CourseNumber}}节</span>
									<i></i>
									<span>{{item.WatchNumber}}浏览</span>
								</hgroup>
								<button type="button" :class="on" class="shou"
									@click="CkeUserAttention(index)">取消关注</button>
							</div>
						</div>
					</li>
				</ul>
				<div class="flex zhong center" style="margin-top: 30px;">
					<el-pagination v-if="IsPage" class="fy" layout="prev, pager, next" @current-change="current_change"
						:page-count="page" :total="total" background></el-pagination>
				</div>
			</div>
			<!-- 没有搜索结果 -->
			<div class="ptend_gao" v-else>
				<div class=" ptend_div">
					<img src="../../image/san/wu_b.png" />
					<p>你未有关注课程</p>
				</div>
			</div>
		</div>

		<!-- 关注文章 -->
		<div class="guan_div" v-show="isTab == 3">
			<div v-if="isWenData">
				<ul>
					<li class="flex float" v-for="(item, index) in tableData" :key="index">
						<div class="li_img" @click="wenTo(item.ContentId)"><img :src="item.PcCoverStr" /></div>
						<div class="li_you">
							<h6 class="shl" @click="wenTo(item.ContentId)">{{item.Title}}</h6>
							<div class="li_time flex float">
								<hgroup class="flex zhong " style=" width: calc( 100% - 100px );" @click="wenTo(item.ContentId)"><span class="shlTwo">{{item.Describle}}</span></hgroup>
								<button type="button" :class="on" class="shou"
									@click="CkeUserAttention(index)">取消关注</button>
							</div>
						</div>
					</li>
				</ul>
				<div class="flex zhong center" style="margin-top: 30px;">
					<el-pagination v-if="IsPage" class="fy" layout="prev, pager, next" @current-change="current_change"
						:page-count="page" :total="total" background></el-pagination>
				</div>
			</div>
			<!-- 没有搜索结果 -->
			<div class="ptend_gao" v-else>
				<div class=" ptend_div">
					<img src="../../image/san/wu_b.png" />
					<p>你未有关注课程</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				isZyPop: false,
				dengA: '-150',
				dengB: '+150',
				input: '',
				Column: {},
				tableData: [],
				IsPage: false,
				total: 0,
				page: 1,
				isTab: 0,
				isGuanData: true,
				isclass: false,
				guanList: [{}, {}, {}],
				isWenData: true,
				isWen: false,
				wenList: [{}, {}, {}]
			};
		},
		created() {
			var that = this;
			that.$api.HtppRequest(
				'Accurate/GetColumnName',
				'GET', {},
				function(res) {
					console.log('获取信息', res);
					if (res.code === 0) {
						that.Column = res.data;
						console.log(that.Column);
						that.getAdmissionPage(1);
					}
				},
				function(err) {
					console.log(err);
				}
			);
		},
		methods: {
			classTo(id) {
				this.$router.push({
					path: '/luboxq',
					query: {
						Id: id
					}
				});
			},
			wenTo(id) {
				this.$router.push({
					path: '/mediaDetails',
					query: {
						Id: id
					}
				});
			},
			onTab(index) {
				this.isTab = index;
				this.getAdmissionPage(1);
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				console.log('Type=' + row.Type);
				if (row.Type === 1) {
					return 'warning-row';
				} else if (row.Type === 2) {
					return 'success-row';
				}
				return '';
			},
			current_change: function(currentPage) {
				this.page = currentPage;
				this.getAdmissionPage(currentPage);
			},
			getAdmissionPage(pg) {
				var that = this;
				const loading = this.$loading({
					lock: true
				});
				// 1=院校 2=专业 3=课程 4=文章
				var type = this.isTab + 1;
				that.$api.HtppRequest(
					'Accurate/UserAttentionList?page=' + pg + '&pageSize=10&UserId=' + that.$store.state.user.user.Id +
					'&Type=' + type,
					'GET', {},
					function(res) {
						that.IsPage = true;
						console.log('获取列表', res);
						if (res.code === 0) {
							var list = [];
							if (res.data.length > 0) {
								res.data.map(a => {
									if (that.isTab === 0) {
										if (a.Type === 1) {
											list.push(a);
										}
									}
									if (that.isTab === 1) {
										if (a.Type === 2) {
											list.push(a);
										}
									} else {
										list.push(a);
									}
								});
								that.page = pg;
								that.total = res.totalCount;
							} else {
								if (pg === 1) {
									that.total = 1;
								}
							}
							that.tableData = list;
							if (list.length === 0) {
								that.isGuanData = type === 3 ? false : that.isGuanData;
								that.isWenData = type === 4 ? false : that.isWenData;
							}
						} else {
							if (pg === 1) {
								that.total = 1;
							}
						}
						loading.close();
					},
					function(err) {
						console.log(err);
						if (pg === 1) {
							that.total = 1;
						}
						loading.close();
					}
				);
			},
			// 收藏院校
			CkeUserAttention(ixd) {
				console.log('下标：' + ixd);
				var that = this;
				var type = this.isTab + 1;
				that.$api.HtppRequest(
					'Accurate/AttentionAdd?UserId=' + that.$store.state.user.user.Id + '&ContentId=' + that.tableData[
						ixd].ContentId + '&Type=' + type,
					'GET', {},
					function(res) {
						console.log('关注信息', res);
						if (res.code === 0) {
							that.$util.showOk(res.msg);
							that.getAdmissionPage(1);
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			xueTo(schoolname) {
				if (schoolname) {
					window.open(
						`${window.location.origin}${window.location.pathname}#/schoolinfo?schoolname=${schoolname}`);
				}
			},
			zhuanyeTo(id) {
				console.log(id);
				if (id > 0) {
					window.open(`${window.location.origin}${window.location.pathname}#/majorinfo?Id=${id}`);
				}
			}
		}
	};
</script>
<style scoped>
	.li_time i {
		display: block;
		width: 1px;
		height: 16px;
		background-color: #959595;
		margin: 0 20px;
	}

	.li_time span {
		font-size: 14px;
		color: #666666;
	}

	.li_time button.on {
		background-color: #005270;
		color: #fff;
	}

	.li_time button {
		width: 80px;
		height: 34px;
		border-radius: 6px;
		font-size: 14px;
		color: #005270;
		text-align: center;
		line-height: 34px;
		border: solid 1px #005270;
	}

	.li_you h6 {
		font-weight: normal;
		font-size: 18px;
		color: #000;
	}

	.li_you {
		width: calc(100% - 200px);
	}

	.li_img img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.li_img {
		border-radius: 6px;
		width: 180px;
		height: 128px;
		overflow: hidden;
		background: url(../../image/nob.png) no-repeat left top;
		background-size: 100% 100%;
	}

	.guan_div li {
		box-sizing: border-box;
		padding: 20px;
		border: solid 1px #ededed;
		margin-bottom: 20px;
	}

	.guan_div {
		padding: 30px 20px;
	}

	.head_tab p.on {
		color: #005270;
		border-bottom: solid 2px #005270;
	}

	.head_tab p {
		font-size: 16px;
		color: #333;
		height: 62px;
		line-height: 62px;
		margin-right: 30px;
	}

	.head_tab {
		border-bottom: solid 1px #e6e6e6;
		text-indent: 20px;
		position: relative;
	}

	.aside_height li {
		border-bottom: solid 1px #eeeeee;
		padding: 14px 0;
		text-indent: 1em;
		font-size: 14px;
		color: #666666;
	}

	.aside_height {
		height: 320px;
		overflow-y: auto;
		border-radius: 6px;
		border: solid 1px #eeeeee;
	}

	.tbc_tabel.active /deep/.el-table--border td {
		background-color: #fff4ee;
	}

	/deep/.el-table thead.is-group th {
		background-color: #bddcf6;
	}

	/deep/.el-table--border td {
		background-color: #ddebf7;
	}

	.name_div>p {
		font-size: 12px !important;
		color: #999 !important;
		text-align: left !important;
	}

	.name_div>p span {
		color: #666 !important;
	}

	.table img.scImg {
		display: block;
		width: 20px;
		height: 20px;
		margin: 0 auto;
		cursor: pointer;
	}

	.table p {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	/deep/.el-table td,
	/deep/.el-table th {
		padding: 5px 0 !important;
	}

	/deep/.cell {
		text-align: center;
		font-size: 14px;
		font-weight: normal;
		color: #333;
	}

	.table p span {
		font-size: 14px;
		color: #333;
		padding-bottom: 8px;
		border-bottom: solid 1px #333;
		line-height: initial;
		margin: 0 10px;
		cursor: pointer;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
		color: #666666;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */

	.tbc_tabel {
		width: 100%;
		margin-top: 30px;
		/* 	min-height: 400px;
	max-height: 800px;
	overflow: auto; */
	}

	/* tbc_tabel */

	.aside_btn .zhun_btn {
		background-color: #333;
		border: solid 1px #333;
	}

	.aside_btn .zhun_btn:first-child {
		background-color: #fff;
		color: #333;
		border: solid 1px #333;
	}

	.aside_btn {
		margin-top: 40px;
	}

	.aside_box {
		width: 70%;
		margin: 0 10px;
	}

	.aside_div {
		width: 90%;
		margin: 0 auto;
	}

	.aside_pop {
		width: 520px;
		border-radius: 10px;
		background-color: #fff;
		padding: 50px 20px 20px 20px;
	}

	/* aside_pop */

	/deep/.el-slider__button-wrapper:nth-child(2)::before {
		content: '-';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button-wrapper:nth-child(3)::before {
		content: '+';
		font-size: 18px;
		font-weight: bold;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		text-align: center;
		line-height: 35px;
	}

	/deep/.el-slider__button {
		width: 24px;
		height: 24px;
		background-color: #fff;
		border: solid 1px #dddddd;
		border-radius: 4px;
	}

	/deep/.el-slider__bar {
		background-color: #f3af3b;
	}

	/deep/.el-slider__runway {
		background-color: #fce4d6;
	}

	/deep/.el-slider__stop {
		background-color: transparent;
	}

	.block {
		width: 360px;
		margin: 0 20px;
	}

	.aside_div /deep/input {
		padding: 0 !important;
		text-align: center;
	}

	.tba_dl p {
		font-size: 14px;
		color: #333;
		margin: 0 10px;
	}

	.tba_dl label {
		font-size: 14px;
		color: #333;
		width: 80px;
		text-align: right;
		margin-right: 10px;
	}

	.tba_dl {
		min-width: 50px;
	}

	.div_padding li:nth-child(n + 2) {
		/* margin-top: 15px; */
		margin-top: 10px;
	}

	.zhun_btn.on {
		background-color: #333;
	}

	.zhun_btn {
		width: 120px;
		height: 40px;
		background-color: #666666;
		border-radius: 4px;
		font-size: 14px;
		color: #fff;
		line-height: 40px;
		margin-right: 20px;
		display: block;
		cursor: pointer;
	}

	.zhun_btn:last-child {
		margin-right: 0;
	}

	/* zhun_btn */

	.div_padding {
		padding: 20px;
		width: 100%;
		border: solid 1px #dddddd;
		margin: 20px 0;
	}

	/* div_padding */

	.three_div p.on {
		background-color: #333;
		color: #fff;
	}

	.three_div p {
		width: 180px;
		height: 40px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		border: solid 1px #dddddd;
		border-bottom: none;
		font-size: 16px;
		color: #333;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
	}

	.three_div {
		margin: 20px 0;
		border-bottom: solid 2px #333;
	}

	/* three_div */
	.tb_padding {
		padding: 0px 20px 1px 20px;
	}

	.gkTest-step {
		margin-top: 0;
	}

	.gaokao-content {
		background-color: #fff;
		margin-bottom: 40px;
		width: 940px !important;
	}

	/deep/.warning-row {
		background: #fff4ee !important;
	}

	/deep/.success-row {
		background: #bddcf6 !important;
	}

	/deep/.el-table--border td {
		background-color: transparent;
	}
</style>
